import { prepararImagenWebp } from './prepararImagenWebp.js';

const MAX_LADO_PX = 1080;
const MAX_ENTRADA_BYTES = 12 * 1024 * 1024;
const MAX_SALIDA_BYTES = 500 * 1024;

export async function prepararFotoProducto(file) {
  const base = (file?.name || 'foto').replace(/\.[^.]+$/, '') + '_prod';
  return prepararImagenWebp({
    file,
    maxInputBytes: MAX_ENTRADA_BYTES,
    maxSidePx: MAX_LADO_PX,
    maxOutputBytes: MAX_SALIDA_BYTES,
    outputNameBase: base,
    emptyFileMessage: 'Archivo de foto vacío.',
    tooLargeMessage: 'La foto supera 12 MB. Elegí una imagen más liviana.',
    invalidTypeMessage: 'Las fotos del producto deben ser imágenes.',
  });
}
